const MuiListItemText = {
  styleOverrides: {
    root: () => ({
      margin: 0,
      color: "inherit"
    }),
    secondary: ({ theme }) => ({
      color: theme.palette.text.secondary
    })
  }
};
export {
  MuiListItemText
};
//# sourceMappingURL=MuiListItemText.js.map
